import { useSyncExternalStore } from "react";

const subscribe = (notify: () => void) => {
  window.addEventListener("popstate", notify);
  return () => window.removeEventListener("popstate", notify);
};
const snapshot = () => window.location.pathname + window.location.search;

export function useLocation() {
  const href = useSyncExternalStore(subscribe, snapshot);
  const url = new URL(href, window.location.origin);
  return { path: url.pathname.replace(/\/+$/, "") || "/", query: url.searchParams };
}

export function href(path: string, params: Record<string, string | undefined | null> = {}) {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) q.set(k, v);
  const s = q.toString();
  return s ? `${path}?${s}` : path;
}

export function navigate(to: string, { replace = false } = {}) {
  if (/^https?:\/\//.test(to) && new URL(to).origin !== window.location.origin) {
    window.location.assign(to);
    return;
  }
  const url = new URL(to, window.location.origin);
  window.history[replace ? "replaceState" : "pushState"]({}, "", url.pathname + url.search);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

/** Leave the portal for a URL Kratos or Hydra returned. */
export function leave(to: string) {
  window.location.assign(to);
}
